module.exports = __webpack_public_path__ + "img/BRamShip64_ua.cd4d5dec.webp";